import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35a59c00"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "services-section",
  id: "services-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Services", -1))

import ServiceCard from '@/components/ServiceCard.vue';
import j_services from '@/json/services.json';
import Service from '@/types/Service.type';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesSection',
  setup(__props) {

const services: Service[] = j_services.services;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (s, idx) => {
      return (_openBlock(), _createBlock(ServiceCard, {
        key: idx,
        service: s
      }, null, 8, ["service"]))
    }), 128))
  ]))
}
}

})